import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Multiseaterbusonrent() {



    const cardData = {





keyword: "32, 35, 40, 45, 50 Seater Bus on Rent in Shirdi",

headingDescription: "Sai Shirdi Cab provides 32, 35, 40, 45, and 50 Seater Bus on Rent in Shirdi for large groups planning pilgrimage tours, corporate travel, educational trips, family functions, sightseeing programs, social events, and multi-day Maharashtra journeys. Different seating capacities make it easier to select a bus according to the number of passengers, luggage requirements, trip duration, and travel itinerary. Large groups can hire a suitable bus with a professional driver for Shirdi Sai Baba darshan, temple tours, airport and railway station transfers, local sightseeing, one-way transportation, round trips, and customized outstation tours. With comfortable seating, well-maintained vehicles, experienced drivers, practical luggage space, flexible pickup and drop arrangements, and planned route options, Sai Shirdi Cab helps groups travel together without the inconvenience of arranging multiple cars. The service is suitable for religious organizations, tour operators, schools, colleges, companies, families, and large private groups traveling across Maharashtra and nearby destinations.",

topPlaces: [
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is one of the most popular pilgrimage destinations near Shirdi and is frequently visited by large devotional groups. A 32 to 50 seater bus provides convenient transportation for everyone to travel together for darshan and return travel. Groups can plan a same-day religious trip or combine the destination with other nearby temples."
  },
  {
    title: "Nashik",
    description: "Nashik is an important religious, cultural, and commercial city with several temples, heritage locations, and sightseeing attractions. Large families, tour operators, and pilgrimage groups can hire a suitable seating-capacity bus from Shirdi for a comfortable group journey. The itinerary can include multiple Nashik attractions and convenient return arrangements."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a prominent Jyotirlinga pilgrimage destination near Nashik and is ideal for organized religious tours from Shirdi. Large groups can select a 32, 35, 40, 45, or 50 seater bus based on their passenger count. Traveling together makes temple visits and group coordination easier throughout the journey."
  },
  {
    title: "Saptashrungi Gad",
    description: "Saptashrungi Gad is a revered Shakti pilgrimage destination surrounded by the Sahyadri landscape. Religious organizations, families, and tour groups can hire a large-capacity bus from Shirdi for convenient transportation to the hill shrine. Customers can also include Nashik and other pilgrimage destinations in the same customized tour."
  },
  {
    title: "Grishneshwar",
    description: "Grishneshwar is an important Jyotirlinga shrine and a popular stop on Maharashtra pilgrimage circuits. Large groups traveling from Shirdi can hire a suitable bus and keep all passengers together throughout the journey. The trip can be combined with Ellora Caves and other nearby attractions for a complete religious and heritage tour."
  },
  {
    title: "Ellora Caves",
    description: "Ellora Caves are a major heritage attraction near Grishneshwar and are suitable for educational groups, tourists, families, and cultural tour parties. A large-capacity bus provides practical transportation for organized groups visiting the ancient rock-cut monuments. Customers can combine Ellora with Grishneshwar in a customized Shirdi tour."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is a prominent heritage and cultural destination with historic monuments, caves, temples, and other attractions. Schools, colleges, families, corporate teams, and tour groups can hire a large bus from Shirdi for organized travel. Different seating capacities allow groups to select a vehicle matching their passenger requirements."
  },
  {
    title: "Pune",
    description: "Pune is a major business and educational center and is suitable for large group transfers from Shirdi. Companies, educational institutions, families, and tour operators can choose a 32 to 50 seater bus for coordinated transportation. Customers can arrange direct travel, event transfers, or extended Maharashtra tours."
  },
  {
    title: "Mumbai",
    description: "Mumbai is a major metropolitan destination frequently connected with Shirdi for business travel, family events, tourism, and group transportation. Hiring a large-capacity bus allows everyone to travel together during the long journey. Customers can plan convenient pickup and drop locations for hotels, offices, event venues, or residential areas."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station known for scenic viewpoints, waterfalls, valleys, lakes, and strawberry farms. Large families and organized tour groups can hire a bus from Shirdi for a comfortable multi-day holiday. The itinerary can also include Panchgani, Wai, and other nearby sightseeing destinations."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is an important religious and cultural destination known for the Mahalaxmi Temple, historic attractions, and regional heritage. Large pilgrimage groups can hire a suitable seating-capacity bus from Shirdi for convenient group travel. The journey can be organized as a direct transfer, round trip, or multi-destination Maharashtra tour."
  },
  {
    title: "Satara",
    description: "Satara offers forts, waterfalls, historical attractions, and scenic Sahyadri surroundings, making it suitable for organized group sightseeing. Tour operators, families, and social groups can hire a large bus from Shirdi for comfortable transportation. Flexible stops can be included according to the group's sightseeing plan."
  },
  {
    title: "Alibaug",
    description: "Alibaug is a popular coastal destination known for beaches, forts, resorts, and seaside attractions. Large families, corporate groups, and tour parties can hire a 32 to 50 seater bus from Shirdi for weekend or multi-day travel. Customers can create a customized itinerary covering beaches and nearby coastal attractions."
  }
],



"services": [
{
"name": "32 Seater Bus Hire Near Me in Shirdi",
"description": "32 Seater Bus Hire Near Me in Shirdi provides a practical group transportation option for families, pilgrims, organizations, and tour groups. The bus can be arranged for local sightseeing, temple visits, group transfers, events, and planned outstation journeys from Shirdi."
},
{
"name": "32 Seater Bus Hire for Outstation in Shirdi",
"description": "32 Seater Bus Hire for Outstation in Shirdi is suitable for groups traveling together to nearby cities, pilgrimage destinations, tourist locations, and multi-day tours. The vehicle offers organized group transportation with seating capacity suitable for larger travel parties."
},
{
"name": "32 Seater Bus Rate Per Km in Shirdi",
"description": "32 Seater Bus Rate Per Km in Shirdi helps groups estimate transportation expenses before planning an outstation journey. The applicable rate can depend on the route, total distance, trip duration, vehicle requirements, driver charges, and whether the booking is one-way or round-trip."
},
{
"name": "35 Seater Bus on Rent in Shirdi",
"description": "35 Seater Bus on Rent in Shirdi offers comfortable group transportation for pilgrimage tours, family travel, sightseeing, educational trips, and corporate requirements. The bus can be booked according to the planned route, passenger count, travel duration, and itinerary."
},
{
"name": "35 Seater Tourist Bus Near Me in Shirdi",
"description": "35 Seater Tourist Bus Near Me in Shirdi provides a convenient option for groups looking for spacious transportation within Shirdi and surrounding destinations. It can be arranged for sightseeing tours, temple visits, family outings, group transfers, and private travel."
},
{
"name": "35 Seater Tourist Bus for Outstation in Shirdi",
"description": "35 Seater Tourist Bus for Outstation in Shirdi is designed for larger groups planning journeys beyond Shirdi. The bus can be used for Maharashtra sightseeing, pilgrimage circuits, family tours, educational trips, and multi-day outstation travel."
},
{
"name": "35 Seater Bus for Corporate Office in Shirdi",
"description": "35 Seater Bus for Corporate Office in Shirdi provides organized employee transportation for companies requiring group travel. The bus can be arranged for office transfers, meetings, conferences, employee movement, corporate events, and scheduled business travel."
},
{
"name": "35 Seater Bus for Corporate Outing in Shirdi",
"description": "35 Seater Bus for Corporate Outing in Shirdi is suitable for companies planning employee outings, team activities, picnics, and group tours. A private bus can accommodate employees traveling together while supporting planned sightseeing and outstation itineraries."
},
{
"name": "40 Seater Tourist Bus Near Me Shirdi",
"description": "40 Seater Tourist Bus Near Me Shirdi offers spacious transportation for larger families, tour groups, organizations, and pilgrimage parties. The vehicle can be arranged for sightseeing, temple tours, group transfers, events, and extended travel from Shirdi."
},
{
"name": "40 Seater Bus Rent Per Km in Shirdi",
"description": "40 Seater Bus Rent Per Km in Shirdi helps travelers understand the pricing factors involved in hiring a large-capacity bus. Rates may vary according to the total kilometers, route, journey duration, vehicle requirements, driver charges, and selected trip type."
},
{
"name": "40 Seater Bus on Rent in Shirdi",
"description": "40 Seater Bus on Rent in Shirdi provides group transportation for religious tours, family trips, sightseeing programs, school groups, corporate travel, and private events. The bus can be planned for local as well as outstation routes."
},
{
"name": "40 Seater Bus on Rent in Shirdi for Wedding",
"description": "40 Seater Bus on Rent in Shirdi for Wedding provides convenient transportation for guests traveling between hotels, venues, railway stations, airports, and nearby locations. The large seating capacity helps families organize coordinated group travel for wedding functions."
},
{
"name": "45 Seater Bus Near Me for Rent",
"description": "45 Seater Bus Near Me for Rent offers a spacious travel solution for large groups requiring private transportation. The bus can be arranged for pilgrimage tours, family journeys, school trips, corporate outings, sightseeing programs, and outstation travel from Shirdi."
},
{
"name": "45 Seater Bus for School Trip",
"description": "45 Seater Bus for School Trip is suitable for educational tours, sightseeing excursions, and student group travel. The vehicle provides organized transportation for school groups visiting destinations around Shirdi and other outstation locations according to the planned itinerary."
},
{
"name": "45 Seater Bus Price Per Km in Shirdi",
"description": "45 Seater Bus Price Per Km in Shirdi helps schools, families, companies, and tour organizers plan their transportation budget. The overall rental amount can depend on distance, route, number of travel days, vehicle requirements, and additional journey arrangements."
},
{
"name": "50 Seater Bus Rental Services in Shirdi",
"description": "50 Seater Bus Rental Services in Shirdi provide high-capacity transportation for large groups traveling together. The bus can be arranged for pilgrimage tours, family functions, corporate programs, educational trips, sightseeing, events, and multi-day outstation journeys."
},
{
"name": "50 Seater Bus for Corporate Outing Near Me",
"description": "50 Seater Bus for Corporate Outing Near Me is suitable for companies organizing large employee groups for picnics, team outings, conferences, and destination trips. Private bus transportation can be planned around the company's preferred route and travel schedule."
},
{
"name": "50 Seater Bus Hire in Shirdi",
"description": "50 Seater Bus Hire in Shirdi provides a convenient transportation solution for large groups requiring coordinated travel. The bus can be used for pilgrimage circuits, family tours, corporate trips, school excursions, sightseeing, and long-distance outstation journeys."
},
{
"name": "32 35 40 45 50 Seater Bus on Rent in Shirdi for Family",
"description": "32 35 40 45 50 Seater Bus on Rent in Shirdi for Family provides multiple seating options for families traveling in large groups. Different bus capacities can be selected according to passenger count, luggage requirements, destination, trip duration, and sightseeing plans."
},
{
"name": "32 35 40 45 50 Seater Bus for Outstation Trip",
"description": "32 35 40 45 50 Seater Bus for Outstation Trip offers flexible group transportation for journeys from Shirdi to pilgrimage destinations, tourist cities, hill stations, and other locations. Bus capacity can be selected according to group size and itinerary."
},
{
"name": "32 35 40 45 50 Seater Bus for Corporate Trip",
"description": "32 35 40 45 50 Seater Bus for Corporate Trip provides organized transportation for employee tours, corporate outings, conferences, meetings, and business events. Different seating capacities allow companies to select a suitable bus according to their team size and travel plan."
}
],
"tableData": [
["32 Seater Bus Hire Near Me in Shirdi", "32 Seater Bus Hire for Outstation in Shirdi"],
["32 Seater Bus Rate Per Km in Shirdi", "35 Seater Bus on Rent in Shirdi"],
["35 Seater Tourist Bus Near Me in Shirdi", "35 Seater Tourist Bus for Outstation in Shirdi"],
["35 Seater Bus for Corporate Office in Shirdi", "35 Seater Bus for Corporate Outing in Shirdi"],
["40 Seater Tourist Bus Near Me Shirdi", "40 Seater Bus Rent Per Km in Shirdi"],
["40 Seater Bus on Rent in Shirdi", "40 Seater Bus on Rent in Shirdi for Wedding"],
["45 Seater Bus Near Me for Rent", "45 Seater Bus for School Trip"],
["45 Seater Bus Price Per Km in Shirdi", "50 Seater Bus Rental Services in Shirdi"],
["50 Seater Bus for Corporate Outing Near Me", "50 Seater Bus Hire in Shirdi"],
["32 35 40 45 50 Seater Bus on Rent in Shirdi for Family", "32 35 40 45 50 Seater Bus for Outstation Trip"],
["32 35 40 45 50 Seater Bus for Corporate Trip", "32 Seater Bus Hire in Shirdi"]
],












        whychoose: [
            { 
                WhyChooseheading: "32, 35, 40, 45 & 50 Seater Bus Rental in Shirdi", 
                WhyChoosedescription: "Sai Shirdi Cabs provides large-capacity bus rental options in Shirdi for pilgrimage groups, tour operators, schools, corporate teams, extended families, and other large parties. Different seating capacities help groups select a bus according to their passenger count, luggage, and planned itinerary." 
            }, 
            { 
                WhyChooseheading: "Convenient for Large Shirdi Pilgrimage Groups", 
                WhyChoosedescription: "Large groups visiting Sai Baba Temple can travel together in one dedicated bus instead of arranging several smaller vehicles. The bus can be used for Darshan, hotel transfers, railway station pickups, airport transportation, and nearby pilgrimage visits." 
            }, 
            { 
                WhyChooseheading: "Choose the Right Seating Capacity", 
                WhyChoosedescription: "Whether your group requires a 32, 35, 40, 45, or 50-seater bus, the requirement can be planned according to the number of passengers travelling together. Sharing the exact group size helps identify an appropriate vehicle." 
            }, 
            { 
                WhyChooseheading: "Ideal for Family & Group Tours", 
                WhyChoosedescription: "Extended families, friends, social groups, and organized tour parties can hire a large bus for Shirdi travel. Keeping everyone in one vehicle makes it easier to coordinate departure times, stops, sightseeing, and pilgrimage activities." 
            }, 
            { 
                WhyChooseheading: "Suitable for Multi-Destination Pilgrimage Tours", 
                WhyChoosedescription: "Plan a group pilgrimage covering Shirdi and nearby religious destinations such as Shani Shingnapur, Saptashrungi, Grishneshwar, Trimbakeshwar, or other selected places according to your itinerary and available travel duration." 
            }, 
            { 
                WhyChooseheading: "Useful for School & Corporate Group Travel", 
                WhyChoosedescription: "Large buses can also be arranged for educational tours, corporate outings, employee travel, institutional programs, and organized group transportation where keeping a larger number of passengers together is important." 
            }, 
            { 
                WhyChooseheading: "Practical for Luggage & Extended Trips", 
                WhyChoosedescription: "Groups travelling with personal bags, pilgrimage essentials, and tour luggage can discuss their baggage requirements while selecting the bus. Seating capacity and luggage needs can be considered together when planning the rental." 
            }, 
            { 
                WhyChooseheading: "Book 32 to 50 Seater Bus in Shirdi with Sai Shirdi Cabs", 
                WhyChoosedescription: "Share your travel date, pickup location, destinations, passenger count, luggage details, trip duration, and preferred seating capacity between 32 and 50 seats with Sai Shirdi Cabs to arrange a suitable group bus." 
            } 
        ] 
 
    }; 
 
    const faqData = [ 
        { 
            question: "Can I rent a 32 seater bus in Shirdi?", 
            answer: "Yes, Sai Shirdi Cabs provides large-capacity bus rental arrangements in Shirdi, including 32-seater options for pilgrimage groups, tours, families, schools, and other group travel requirements." 
        }, 
        { 
            question: "Is a 35 seater bus available for Shirdi group travel?", 
            answer: "Yes, a 35-seater bus can be requested for Shirdi pilgrimage trips, sightseeing tours, educational travel, corporate outings, and other group transportation requirements." 
        }, 
        { 
            question: "Can I hire a 40 seater bus in Shirdi?", 
            answer: "Yes, 40-seater bus rental can be discussed for larger groups travelling to Shirdi and nearby destinations. Share your passenger count and itinerary to plan a suitable vehicle." 
        }, 
        { 
            question: "Can I book a 45 seater bus for a Shirdi pilgrimage?", 
            answer: "Yes, a 45-seater bus can be arranged for larger pilgrimage groups, family tours, organized trips, and multi-destination travel plans depending on vehicle availability and requirements." 
        }, 
        { 
            question: "Can I hire a 50 seater bus in Shirdi?", 
            answer: "Yes, 50-seater bus rental can be requested for large groups requiring shared transportation for Shirdi Darshan, sightseeing, tours, institutional travel, or other planned journeys." 
        }, 
        { 
            question: "Can these buses be used for Sai Baba Darshan?", 
            answer: "Yes, large buses can be used for group transportation related to Sai Baba Darshan, including hotel transfers, local travel, railway station pickups, and other planned movements." 
        }, 
        { 
            question: "Can I use a large bus for Shirdi sightseeing?", 
            answer: "Yes, groups can hire a 32 to 50-seater bus for Shirdi sightseeing and include nearby religious or tourist destinations according to their itinerary and available travel time." 
        }, 
        { 
            question: "Can I include Shani Shingnapur in the bus itinerary?", 
            answer: "Yes, Shani Shingnapur can be included in a customized group pilgrimage itinerary along with Shirdi, subject to the selected route, travel duration, and overall tour plan." 
        }, 
        { 
            question: "Can I hire a 32 to 50 seater bus for multiple days?", 
            answer: "Yes, multi-day bus rental can be discussed for extended pilgrimage tours, family holidays, educational trips, corporate outings, and multi-destination group travel." 
        }, 
        { 
            question: "How can I book a 32, 35, 40, 45 or 50 seater bus in Shirdi?", 
            answer: "Share your travel date, pickup location, destinations, passenger count, luggage details, trip duration, and preferred seating capacity with Sai Shirdi Cabs to arrange a suitable large-capacity bus." 
        } 
    ]; 
 
    const testimonials = [ 
        { 
            id: 1, 
            name: "Mr. Rajesh More", 
            feedback: "Our large family group planned a Shirdi pilgrimage and needed transportation for everyone in one vehicle. The large-capacity bus was a practical choice for coordinating our Darshan, hotel transfers, and nearby visits.", 
            rating: 5 
        }, 
        { 
            id: 2, 
            name: "Mrs. Pooja Deshmukh", 
            feedback: "We organized a group trip to Shirdi with many passengers and selected a large bus according to our group size. Keeping everyone together made the overall travel schedule much easier to manage.", 
            rating: 5 
        } 
    ];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "32, 35, 40, 45, 50 Seater Bus on Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/32-35-40-45-50-seater-bus-on-rent-in-shirdi.webp",
  "description":
    "Book 32, 35, 40, 45, and 50 Seater Bus on Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable group transportation. We provide tourist buses for Shirdi Darshan, Sai Baba Temple visits, local sightseeing, pilgrimage tours, family trips, corporate travel, airport transfers, weddings, and outstation journeys. Choose suitable bus sizes with experienced drivers, convenient pickup and drop facilities, and flexible one-way, round-trip, full-day, and customized rental options.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/32-35-40-45-50-seater-bus-on-rent-in-shirdi"
  }
};





    return (
        <div>


<Helmet>
  <title>32, 35, 40, 45, 50 Seater Bus on Rent in Shirdi | +91 7776814559</title>

  <meta
    name="description"
    content="Hire 32, 35, 40, 45 and 50 seater tourist buses in Shirdi with Sai Shirdi Cabs. Get comfortable buses for Shirdi Darshan, sightseeing, pilgrimage tours, family groups, corporate travel, airport transfers and outstation trips with professional drivers."
  />

  <meta
    name="keywords"
    content="32 Seater Bus Hire Near Me in Shirdi, 32 Seater Bus Hire for Outstation in Shirdi, Sai Shirdi Cabs, 32 Seater Bus Rate Per Km in Shirdi, 35 Seater Bus on Rent in Shirdi, 35 Seater Tourist Bus Near Me in Shirdi, 35 Seater Tourist Bus Hire in Shirdi, 32 35 40 45 50 Seater Bus on Rent in Shirdi, 32 Seater Bus on Rent in Shirdi, 35 Seater Bus Hire in Shirdi, 40 Seater Bus on Rent in Shirdi, 45 Seater Bus Hire in Shirdi, 50 Seater Bus on Rent in Shirdi, 32 Seater Tourist Bus Shirdi, 35 Seater Tourist Bus Shirdi, 40 Seater Tourist Bus Shirdi, 45 Seater Tourist Bus Shirdi, 50 Seater Tourist Bus Shirdi, Large Bus Rental in Shirdi, Big Bus on Rent in Shirdi, Tourist Bus Rental Shirdi, Tourist Bus Hire Shirdi, AC Tourist Bus on Rent Shirdi, Shirdi Bus Rental Service, Shirdi Bus Hire Service, Shirdi Group Bus Rental, Shirdi Darshan Bus Hire, Shirdi Sightseeing Bus Rental, Shirdi Pilgrimage Bus Hire, Shirdi Outstation Bus Rental, Shirdi Airport Bus Hire, Shirdi One Day Bus Rental, Shirdi Round Trip Bus Rental, Shirdi Bus for Family Tour, Shirdi Bus for Group Travel, 32 Seater Bus for Outstation Shirdi, 35 Seater Bus for Outstation Shirdi, 40 Seater Bus for Outstation Shirdi, 45 Seater Bus for Outstation Shirdi, 50 Seater Bus for Outstation Shirdi, 32 Seater Bus Rate Shirdi, 35 Seater Bus Rate Shirdi, 40 Seater Bus Rate Shirdi, 45 Seater Bus Rate Shirdi, 50 Seater Bus Rate Shirdi, Bus Rental Per Km Shirdi, Affordable Tourist Bus Shirdi, Best Bus Hire in Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Multiseaterbusonrent;